const ww = window.innerWidth
const wh = window.innerHeight

const s7StaticH = ww / (1125 / 2436)

const sprites = {
  s7_static: {
    size: { mode: 'widthFit', width: 1 },
    position: { x: 1, y: 1 },
    anchor: 'bottomRight'
  },
  s7_wechat1new: {
    size: { mode: 'widthFit', width: 890 / 1125 },
    position: { x: 1 - 36 / 1125, y: 1 - 242 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_wechat2: {
    size: { mode: 'widthFit', width: 890 / 1125 },
    position: { x: 1 - 36 / 1125, y: 1 - 242 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_wechat3: {
    size: { mode: 'widthFit', width: 890 / 1125 },
    position: { x: 1 - 36 / 1125, y: 1 - 242 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_wechat4: {
    size: { mode: 'widthFit', width: 890 / 1125 },
    position: { x: 1 - 36 / 1125, y: 1 - 242 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_fingernormal: {
    size: { mode: 'widthFit', width: 401 / 1125 },
    position: { x: 1, y: 1 - 756 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_fingergame: {
    size: { mode: 'widthFit', width: 350 / 1125 },
    position: { x: 1, y: 1 - 632 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_fingerwork: {
    size: { mode: 'widthFit', width: 435 / 1125 },
    position: { x: 1, y: 1 - 632 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_fingerexit: {
    size: { mode: 'widthFit', width: 424 / 1125 },
    position: { x: 0, y: 1 },
    anchor: 'bottomLeft'
  },
  s7_fingermother: {
    size: { mode: 'widthFit', width: 619 / 1125 },
    position: { x: 1 - 506 / 1125, y: 1 },
    anchor: 'bottomRight'
  },
  s7_fingermother2: {
    size: { mode: 'widthFit', width: 559 / 1125 },
    position: { x: 1 - 560 / 1125, y: 1 },
    anchor: 'bottomRight'
  },
  s7_static2: {
    size: { mode: 'heightFit', height: 1 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s7_head: {
    size: { mode: 'widthFit', width: 114 / 1125 },
    position: { x: 1 - 620 / 1125, y: 1 - 548 / 2436 * s7StaticH / wh },
    anchor: 'bottomRight'
  },
  s7_text1: {
    size: { mode: 'heightFit', height: 317 / 2172 },
    position: { x: 0, y: 1564 / 2172 },
    anchor: 'bottomLeft'
  },
  s7_text4: {
    size: { mode: 'heightFit', height: 393 / 2172 },
    position: { x: 0, y: 1374 / 2172 },
    anchor: 'bottomLeft'
  },
  s7_text3: {
    size: { mode: 'heightFit', height: 495 / 2172 },
    position: { x: 0, y: 980 / 2172 },
    anchor: 'bottomLeft'
  },
  s7_text2: {
    size: { mode: 'heightFit', height: 377 / 2172 },
    position: { x: 0, y: 760 / 2172 },
    anchor: 'bottomLeft'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s7/sprites.js